import React, { useState, useEffect } from 'react';
import styled from '../../styled';
import { Arrow } from '../icons/outline';
import * as Icons from '../icons';
import * as ImagePreview from '../imagePreview';
import * as Logos from '../logos';
import Text from '../text';
const Container = styled.div `
  position: relative;
  overflow: hidden;
  height: 3.125rem;
  width: inherit;
  background-color: ${({ theme }) => theme.colors.INK_800};
`;
const Circle = styled.div `
  position: absolute;
  top: -2.5rem;
  right: -2.5rem;
  background-color: ${({ bgColor }) => bgColor};
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
`;
const Content = styled.a `
  box-sizing: border-box;
  height: 3.125rem;
  padding: ${({ enableRedirection }) => enableRedirection ? '0.5rem 0.75rem 0.5rem 0.5rem' : '0.5rem 0.75rem'};
  margin-left: ${({ enableRedirection }) => (enableRedirection ? '2rem' : 0)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.INK_700};
  }
`;
const ArrowWrapper = styled.a `
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: #242833;
  width: ${({ isWidthExpand }) => (isWidthExpand ? 'inherit' : '2rem')};
  transition: width 0.3s ease-in;
  padding: 1rem 0.5rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  text-decoration: none;

  > :first-child {
    flex: 0 0 1rem;
  }

  > :nth-child(2) {
    padding-left: 0.25rem;
    flex: ${({ isWidthExpand }) => (isWidthExpand ? '0 0 1.25rem' : '0 1 0')};
    transition: flex 0.3s ease-in;

    > div {
      min-width: initial;
      min-height: initial;
    }
  }

  > :last-child {
    padding-left: 0.25rem;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    width: inherit;

    > :nth-child(2) {
      flex: 0 0 1.25rem;
    }
  }
`;
const PanelHeader = ({ navigationPath, circleBgColor = '#366AB3', Icon = Icons.Brand.AdminReversed, iconColor = 'SNOW_100', Logo = Logos.Shopline, logoColor, hideCircle = false, enableRedirection = false, redirectionPath = '', lang = 'en', merchantName = '', merchantImageUrl = '', renderContent, }) => {
    const [isWidthExpand, setIsWidthExpand] = useState(enableRedirection);
    useEffect(() => {
        const timerId = setTimeout(() => {
            setIsWidthExpand(false);
            clearTimeout(timerId);
        }, 3000);
    }, []);
    return (React.createElement(Container, null,
        !hideCircle && React.createElement(Circle, { bgColor: circleBgColor }),
        React.createElement(Content, { "data-e2e-id": "nav_top_nav", enableRedirection: enableRedirection, href: navigationPath }, renderContent ? (renderContent()) : (React.createElement(React.Fragment, null,
            React.createElement(Logo, { color: logoColor }),
            React.createElement(Icon, { size: "LARGE", color: iconColor })))),
        enableRedirection && (React.createElement(ArrowWrapper, { "data-e2e-id": "nav_top_redirect", href: redirectionPath, isWidthExpand: isWidthExpand },
            React.createElement(Arrow, { color: "INK_400", size: "SMALL", position: "LEFT" }),
            React.createElement(ImagePreview.Thumbnail, { image: merchantImageUrl }),
            React.createElement(Text, { fontType: "Micro", lang: lang, color: "SNOW_100" }, merchantName)))));
};
export default PanelHeader;
//# sourceMappingURL=index.js.map